import type { FC } from 'react'

import { Link } from 'react-router-dom'

import { CreatorHeroLogo } from '@/components/layout/header/logo'
import { AppRoutes } from '@/utils/constants'

import { useAccount } from '../../hooks/useAccounts'

interface Props {
  width?: number
  height?: number
  useLink?: boolean
}

export const AgencyLogo: FC<Props> = ({
  width = 150,
  height = 25,
  useLink = true,
}) => {
  const { agencyLogoCurrent } = useAccount()

  return useLink ? (
    <Link to={AppRoutes.Overview.asUrl()}>
      {agencyLogoCurrent ? (
        <img
          src={agencyLogoCurrent}
          alt="agency logo"
          className="object-contain"
          style={{ width: `${width}px`, height: `${height}px` }}
        />
      ) : (
        <CreatorHeroLogo
          width={150}
          useLink={false}
        />
      )}
    </Link>
  ) : agencyLogoCurrent ? (
    <img
      src={agencyLogoCurrent}
      alt="agency logo"
      className="object-contain"
      style={{ width: `${width}px`, height: `${height}px` }}
    />
  ) : (
    <CreatorHeroLogo
      width={150}
      useLink={false}
    />
  )
}
